const HEALTH_CHECK_PMS_PATH = '/healthCheck/pms'

/**
 * Builds a dashboard URL that opens PMS Health Check for one hotel.
 * When openTelemetry is true, the telemetry modal opens after the list loads.
 *
 * @param {object} options
 * @param {string} [options.baseUrl] - e.g. https://dashboard.directful.com (no trailing slash)
 * @param {number|string} [options.displayId]
 * @param {string} [options.subsidiaryId]
 * @param {boolean} [options.openTelemetry]
 * @param {boolean} [options.pepOnly]
 * @param {string} [options.action] - PEP CSM action filter key
 * @param {boolean} [options.queue] - Apply "my queue" preset (hide healthy, PEP only)
 */
export function buildHealthCheckPmsDeepLink({
  baseUrl = '',
  displayId,
  subsidiaryId,
  openTelemetry = false,
  pepOnly = true,
  action,
  queue = false
}) {
  const params = new URLSearchParams()

  if (displayId != null && String(displayId).trim() !== '') {
    params.set('q', String(displayId).trim())
  }

  if (subsidiaryId != null && String(subsidiaryId).trim() !== '') {
    params.set('subsidiaryId', String(subsidiaryId).trim())
  }

  if (openTelemetry) {
    params.set('telemetry', '1')
  }

  if (pepOnly) {
    params.set('pms', 'pep')
  }

  if (action != null && String(action).trim() !== '') {
    params.set('action', String(action).trim())
  }

  if (queue) {
    params.set('queue', '1')
  }

  const origin = String(baseUrl || '').replace(/\/$/, '')
  const query = params.toString()

  return `${origin}${HEALTH_CHECK_PMS_PATH}${query ? `?${query}` : ''}`
}

export function buildHealthCheckPmsTelemetryLink(options) {
  return buildHealthCheckPmsDeepLink({ ...options, openTelemetry: true })
}

export function buildHealthCheckPmsListLink(options) {
  return buildHealthCheckPmsDeepLink({ ...options, openTelemetry: false })
}

/**
 * @param {string} search - location.search, with or without leading ?
 */
export function parseHealthCheckPmsDeepLinkQuery(search) {
  const raw = String(search || '').replace(/^\?/, '')
  const params = new URLSearchParams(raw)

  const q = params.get('q')
  const subsidiaryId = params.get('subsidiaryId')
  const telemetry = params.get('telemetry')
  const pms = params.get('pms')
  const action = params.get('action')
  const queue = params.get('queue')

  const searchQuery = q != null && q.trim() !== '' ? q.trim() : null
  const openTelemetry = telemetry === '1' || telemetry === 'true'
  const pepOnly = pms === 'pep'
  const actionKey = action != null && action.trim() !== '' ? action.trim() : null
  const queuePreset = queue === '1' || queue === 'true'

  const hasDeepLink =
    searchQuery != null ||
    (subsidiaryId != null && subsidiaryId.trim() !== '') ||
    openTelemetry ||
    pepOnly ||
    actionKey != null ||
    queuePreset

  return {
    hasDeepLink,
    searchQuery,
    subsidiaryId: subsidiaryId != null && subsidiaryId.trim() !== '' ? subsidiaryId.trim() : null,
    openTelemetry,
    pepOnly,
    actionKey,
    queuePreset
  }
}
